// Provides utility methods for language selection and localisation

const LANGUAGES_BY_ID: object = {
    30: 'en',
    43: 'de'
};

export default class LanguageHandler {

    // Get language code if localisation supported
    // Otherwise returns 'none' string
    public static getLocalisationCode(id) {
        if (Object.keys(LANGUAGES_BY_ID).includes(id)) {
            return LANGUAGES_BY_ID[id];
        } else {
            return undefined;
        }
    }

    public static getLocaleId(code) {
        return Object.keys(LANGUAGES_BY_ID).find((key) => LANGUAGES_BY_ID[key] === code);
    }

    public static getDefaultLocale() {

        const langs = navigator.languages;
        let lang: string;
        for (lang of langs) {

            if (lang.length === 5) {
                // e.g. en-GB
                lang = lang.slice(0, 2);
            }

            // Check if this language is supported
            if (Object.values(LANGUAGES_BY_ID).includes(lang)) {
                return lang;
            }
        }

        return null;
    }
}
